import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

/**
 * @typedef AuthSlice
 * @property {string} accessToken
 * @property {string} tokenType
 * @property {Location | null} location
 */

export const login = createAsyncThunk(
  "auth/login",
  async (accessToken, { dispatch }) => {
    dispatch(updateAccessToken(accessToken));
  },
);

export const authSlice = createSlice({
  name: "auth",
  initialState: { accessToken: null, user: null, location: null },
  reducers: {
    updateAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    logout: (state) => {
      state.accessToken = null;
      state.user = null;
      state.location = null;
    },
    /**
     * @param {AuthSlice} state
     * @param {{payload: User | null}} action
     * @returns {void}
     */
    setUser: (state, action) => {
      state.user = action.payload;
    },
    /**
     * @param {AuthSlice} state
     * @param {{payload: Location | null}} action
     * @returns {void}
     */
    setLocation: (state, action) => {
      state.location = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => {
      state.user = action.payload;
    });
  },
});

export const { updateAccessToken, logout, setUser, setLocation } =
  authSlice.actions;
/**
 * @param {import('./store.js').CyberpassStore} state
 * @returns {AccessToken | null}
 */
export const selectAccessToken = (state) => state.auth.accessToken;
/**
 * @param {import('./store.js').CyberpassStore} state
 * @returns {User | null}
 */
export const selectUser = (state) => state.auth.user;
/**
 * @param {import('./store.js').CyberpassStore} state
 * @returns {Location | null}
 */
export const selectLocation = (state) => state.auth.location;

export default authSlice.reducer;
